import React from "react";

class FileDownloadModal extends React.Component {
  constructor(props) {
    super(props);

    this.url = "/api/product/FileDownload";
    this.formEntries = this.loadEntries();
    this.onSubmit = this.onSubmit.bind(this);
    this.elementChanged = this.elementChanged.bind(this);
    this.dropDownChanged = this.dropDownChanged.bind(this);
    this.toggleCountryDropDown = this.toggleCountryDropDown.bind(this);

    this.state = {
      countryDropDown: false,
      countryMissing: false,
      error: false,
      ...this.formEntries,
    };
  }

  componentDidMount() {
    let productAreaElement = document.getElementById("selectedProductArea");
    if (productAreaElement) {
      this.formEntries.productArea = productAreaElement.value;
    } else {
      this.formEntries.productArea = null;
    }
  }

  isFormSubmitted() {
    return this.hasEntries() && sessionStorage.getItem("download-form-submitted") === "true";
  }

  setFormSubmitted() {
    sessionStorage.setItem("download-form-submitted", "true");
  }

  saveEntries() {
    if (this.hasEntries()) {
      localStorage.setItem("download-form-entries", JSON.stringify(this.formEntries));
    }
  }

  hasEntries() {
    return (
      this.formEntries.firstName !== "" &&
      this.formEntries.lastName !== "" &&
      this.formEntries.company !== "" &&
      this.formEntries.country !== "" &&
      this.formEntries.eMail !== ""
    );
  }

  toggleCountryDropDown() {
    this.setState({
      countryDropDown: !this.state.countryDropDown,
    });
  }

  loadEntries() {
    return (
      JSON.parse(localStorage.getItem("download-form-entries")) || {
        firstName: "",
        lastName: "",
        company: "",
        country: "",
        eMail: "",
        phone: "",
        productArea: "",
      }
    );
  }

  elementChanged(e) {
    let elemName = e.target.name;
    let elemValue = e.target.value;

    this.formEntries[elemName] = elemValue;
    this.setState((state) => {
      state[elemName] = elemValue;
      return state;
    });
  }

  dropDownChanged(e) {
    this.formEntries[e.target.name] = e.target.value;
    this.setState({
      countryMissing: false,
    });
    this.toggleCountryDropDown();
  }

  onSubmit(e) {
    if (e) {
      e.preventDefault();
      }

    if (!this.formEntries.country) {
      this.setState({
        countryMissing: true,
      });

      return;
    }

    this.setState({
      countryMissing: false,
      error: false,
    });

    this.saveEntries();
    this.sendInformation();
  }

    sendInformation() {
       // Set submittedFirsttime if not already set in sessionStorage, only true on first submit in session
      if (!sessionStorage.getItem("submittedFirsttime")) {
        sessionStorage.setItem("submittedFirsttime", "true");
        this.formEntries.submittedFirsttime = true;
      } else {
        sessionStorage.setItem("submittedFirsttime", "false");
        this.formEntries.submittedFirsttime = false;
      }

    let self = this;
    fetch(this.url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filePath: this.props.fileUrl,
        articleNo: this.props.fileDownloadSelectedArticleName,
        ...this.formEntries,
      }),
    }).then((response) => {
        if (!response.ok) {
            if (response.status === 429) {
                self.setState({
                error: true,
                errorCode: 429,
                });
            } else {
                self.setState({
                error: true,
                errorCode: response.status,
                });
            }
        return;
        }

      self.setFormSubmitted();
      self.setState({ error: false, errorCode: null });
      self.downloadFile();
      self.props.onClose();
    });
  }

  downloadFile() {
    if (!this.props.fileUrl) {
      return;
    }

    var element = document.createElement("a");
    element.setAttribute("href", this.props.fileUrl);
    element.setAttribute("download", "");
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  render() {
    if (!this.props.open) {
      return null;
    }

    if (this.isFormSubmitted() && !this.state.error) {
      this.sendInformation();
      return null;
    }

    return (
      <>
        <div className="c-download-modal" role="dialog" aria-hidden={this.props.open ? false : true}>
          <a className="c-download-modal__close" aria-label="Close modal" onClick={this.props.onClose}>
                <i className="icon-clear"></i>
          </a>
          <div className="c-download-modal__outer">
            <div className="c-download-modal__inner">
              <h3 className="c-download-modal__heading">{i18n.getString("articlemodal.downloadform.heading")}</h3>
              <p className="c-download-modal__paragraph">{i18n.getString("articlemodal.downloadform.description")}</p>
              <form className="c-download-modal__form" onSubmit={this.onSubmit}>
                <input type="hidden" name="productArea" value={this.formEntries.productArea} />
                <div className="c-download-modal__input-group">
                  <label htmlFor="firstName" className="c-download-modal__label">
                    {i18n.getString("articlemodal.downloadform.firstname")}
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    value={this.state.firstName}
                    onChange={this.elementChanged}
                    className="c-download-modal__input"
                    autoComplete="given-name"
                    required
                  />
                </div>
                <div className="c-download-modal__input-group">
                  <label htmlFor="lastName" className="c-download-modal__label">
                    {i18n.getString("articlemodal.downloadform.lastname")}
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={this.state.lastName}
                    onChange={this.elementChanged}
                    className="c-download-modal__input"
                    autoComplete="family-name"
                    required
                  />
                </div>
                <div className="c-download-modal__input-group">
                  <label htmlFor="company" className="c-download-modal__label">
                    {i18n.getString("articlemodal.downloadform.company")}
                  </label>
                  <input
                    type="text"
                    name="company"
                    id="company"
                    value={this.state.company}
                    onChange={this.elementChanged}
                    className="c-download-modal__input"
                    autoComplete="organization"
                    required
                  />
                </div>
                {i18n.languages ? (
                  <div className="c-download-modal__input-group">
                    <label htmlFor="country" className="c-download-modal__label">
                      {i18n.getString("articlemodal.downloadform.country")}
                    </label>
                    <div className="c-filter-dropdown">
                      <button
                        type="button"
                        className={
                          this.state.countryDropDown
                            ? "c-filter-dropdown__select c-filter-dropdown__select--open"
                            : "c-filter-dropdown__select"
                        }
                        onClick={this.toggleCountryDropDown}
                      >
                        {this.formEntries.country
                          ? this.formEntries.country
                          : i18n.getString("articlemodal.downloadform.selectcountry")}
                        <i className="icon-keyboard_arrow_down"></i>
                      </button>
                      <div className="c-filter-dropdown__list">
                        {i18n.languages.map((language) => {
                          return (
                            <div
                              key={language.value}
                              className={
                                this.formEntries.country === language.value
                                  ? "c-filter-dropdown__list-item c-filter-dropdown__list-item--active"
                                  : "c-filter-dropdown__list-item"
                              }
                            >
                              <label htmlFor={language.value}>
                                {language.name}
                                <input
                                  type="radio"
                                  id={language.value}
                                  name="country"
                                  value={language.value}
                                  onChange={this.dropDownChanged}
                                  checked={this.formEntries.country === language.value}
                                />
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      {this.state.countryMissing ? (
                        <p className="c-download-modal__paragraph">
                          {i18n.getString("articlemodal.downloadform.countryMissing")}
                        </p>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                <div className="c-download-modal__input-group">
                  <label htmlFor="email" className="c-download-modal__label">
                    {i18n.getString("articlemodal.downloadform.email")}
                  </label>
                  <input
                    type="email"
                    name="eMail"
                    id="email"
                    value={this.state.eMail}
                    onChange={this.elementChanged}
                    className="c-download-modal__input"
                    autoComplete="email"
                    required
                  />
                </div>

                <div className="c-download-modal__input-group">
                  <label htmlFor="phone" className="c-download-modal__label">
                    {i18n.getString("articlemodal.downloadform.phone")}
                  </label>
                  <input
                    type="text"
                    name="phone"
                    id="phone"
                    value={this.state.phone}
                    onChange={this.elementChanged}
                    className="c-download-modal__input"
                    autoComplete="phone"
                  />
                </div>

                <button value="" id="buttonSearchDesktop" type="submit" className="c-download-modal__submit">
                  {i18n.getString("articlemodal.downloadform.submit")}
                </button>
                {this.state.error && this.state.errorCode === 429 ? (
                    <p className="bg-danger mt-4 p-2 text-white">
                    {i18n.getString("articlemodal.downloadform.tooManyRequests")}
                    </p>
                ) : this.state.error ? (
                    <p className="bg-danger mt-4 p-2 text-white">
                    {i18n.getString("articlemodal.downloadform.error")}
                    </p>
                ) : null}
              </form>
            </div>
          </div>
        </div>
        <div className="c-download-modal-overlay" tabIndex="-1" aria-hidden={this.props.open ? false : true} onClick={this.props.onClose}></div>
      </>
    );
  }
}
export default FileDownloadModal;
